export default __webpack_public_path__ + "assets/4020a5de7d2a23667d6d92cd5d848e3a.svg";